import DashboardLayout from "../../../shared/DashboardLayout";

const ViewExpenses = () => {
  return (
    <DashboardLayout>
      <form action="" method="post">
        <div className="row m-4">
          <div className="col-lg-1">
            <label for="id" className="fw-bolder">
              Invoice#
            </label>
          </div>
          <div className="col-lg-2 form-group">
            <input
              autofocus=""
              type="number"
              value=""
              id="id"
              name="id"
              autocomplete="off"
              className="form-control"
            />
          </div>
          <div className="col-lg-2">
            <input
              type="submit"
              value="Search"
              className="btn site_btn text-white"
            />
          </div>
        </div>
      </form>
      <h2 className="mx-4">No Record Found.</h2>
    </DashboardLayout>
  );
};

export default ViewExpenses;
